import { useNavigate } from "react-router-dom";
import NoData from "../../assets/img/nodata_gray.svg"
import { useEffect, useState } from "react";
import AppButton from "../elements/AppButton";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useApiRequest from "../../helpers/api_request";
import { showToastMessage } from "../../features/generalSlice";
import { formatDate, notEmpty } from "../../helpers/commons";
import { toast } from "react-toastify";
import { BASE_URL } from "../../helpers/constants";
import { AxiosError } from "axios";
import { selectAccessToken } from "../../features/auth/authSlice";
import AppSpinner from "../elements/AppSpinner";

type TypeRegionData = {
    id:number,
    name: string,
    created_at?: string
}


export type TypeDistrictData = {
    id:number
    name: string,
    created_at?: string,
    region:TypeRegionData
}


const RegionPage = () => {
    const navigate = useNavigate()
    const [activeTab, setActivetab] = useState("region");

    return (
        <div>
            <div className="text-sm font-medium text-center text-gray-500  mx-2 ">
                <ul className="flex flex-wrap -mb-px">
                    <li className="mr-2">
                        <a onClick={() => setActivetab('region')} href="#!" className={(activeTab === 'region') ? "tab-active" : "tab-inactive"}>Regions</a>
                    </li>
                    <li className="mr-2">
                        <a onClick={() => setActivetab('district')} href="#!" className={(activeTab === 'district') ? "tab-active" : "tab-inactive"} aria-current="page">Sub Region</a>
                    </li>
                </ul>
            </div>


            {
                (activeTab === 'region') ?
                    <RegionsCard /> :
                    <DistrictsCard />
            }
        </div>
    )
}

const DistrictsCard = () => {
    const [districtModalOpen, setDistrictModalOpen] = useState(false);
    const [loadingData, setLoadingData] = useState(false)
    const accessToken = useAppSelector(selectAccessToken);
    const apiRequest = useApiRequest()
    const [districtsData, setDistrictsData] = useState<TypeDistrictData[]>([]);

    const dispatch = useAppDispatch();
    useEffect(() => {
        getDistricts();
    }, [])
    const getDistricts = async () => {
        setLoadingData(true);
        await apiRequest({
            method: 'get',
            url: BASE_URL + "/api/districts",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }).then((response) => {
            setLoadingData(false)
            setDistrictsData(response.data)
        }).catch((error) => {
            const errorResponse = error as AxiosError;
            if (errorResponse.response) {
                const data = errorResponse.response.data as { message: string, status: string };
                dispatch(showToastMessage({
                    message: data.message,
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            } else {
                dispatch(showToastMessage({
                    message: "Something went wrong",
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            }
            setLoadingData(false)
        });
    }

    return (
        <div className="card">
            <div className=" card-body min-h-half-screen">
                <div className="flex">

                    <div className="flex-grow flex justify-end">
                        <button onClick={() => setDistrictModalOpen(true)} type="button" className="prim-btn-2 mb-2">New Subregion</button>
                    </div>
                </div>
                {
                    (districtsData.length === 0 && loadingData == false) &&
                    <div className=" h-fit flex-grow flex flex-col justify-center ">
                        <div className="flex justify-center">
                            <div>
                                <img className=" w-32" src={NoData} alt="" />
                                <p>No Records Yet!</p>
                            </div>
                        </div>
                    </div>
                }
                {(loadingData) && <AppSpinner />}
                
                {(districtsData.length > 0) &&
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead>
                            <tr>
                                <th scope="col" >
                                    Name
                                </th>
                                <th scope="col" >
                                    Region
                                </th>
                                <th scope="col" >
                                    Created
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                districtsData.map((item, key) =>
                                    <tr key={key}>
                                        <td>{item.name}</td>
                                        <td>{item.region.name}</td>
                                        <td>{(item.created_at) && formatDate(item.created_at, "MMM DD, YYYY H:mm")}</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                }
            </div>
            <DistrictsModal onClose={() => setDistrictModalOpen(false)} isOpen={districtModalOpen} districtCreated={() => getDistricts()} />
        </div>
    );
}





const RegionsCard = () => {
    const [regionsModalOpen, setRegionsModalOpen] = useState(false);
    const [loadingData, setLoadingData] = useState(false)
    const accessToken = useAppSelector(selectAccessToken);
    const apiRequest = useApiRequest()
    const [regionsData, setRegionsData] = useState<TypeRegionData[] | []>([]);
    const dispatch = useAppDispatch();
    useEffect(() => {
        getRegions();
    }, [])

    const getRegions = async () => {
        setLoadingData(true);
        await apiRequest({
            method: 'get',
            url: BASE_URL + "/api/regions",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }).then((response) => {
            setLoadingData(false)
            setRegionsData(response.data)
        }).catch((error) => {
            const errorResponse = error as AxiosError;
            if (errorResponse.response) {
                const data = errorResponse.response.data as { message: string, status: string };
                dispatch(showToastMessage({
                    message: data.message,
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            } else {
                dispatch(showToastMessage({
                    message: "Something went wrong",
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            }
            setLoadingData(false)
        });
    }

    return (
        <div className="card">
            <div className=" card-body min-h-half-screen">
                <div className="flex">

                    <div className="flex-grow flex justify-end">
                        <button onClick={() => setRegionsModalOpen(true)} type="button" className="prim-btn-2 mb-2">New Region</button>
                    </div>
                </div>

                {
                    (regionsData.length === 0 && loadingData == false) &&
                    <div className=" h-fit flex-grow flex flex-col justify-center ">
                        <div className="flex justify-center">
                            <div>
                                <img className=" w-32" src={NoData} alt="" />
                                <p>No Records Yet!</p>
                            </div>
                        </div>
                    </div>
                }
                {(loadingData) && <AppSpinner />}

                {(regionsData.length > 0) &&
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead>
                            <tr>
                                <th scope="col" >
                                    Name
                                </th>
                                <th scope="col" >
                                    Created
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                regionsData.map((item, key) =>
                                    <tr key={key}>
                                        <td>{item.name}</td>
                                        <td>{(item.created_at) && formatDate(item.created_at, "MMM DD, YYYY H:mm")}</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                }
            </div>
            <RegionsModal onClose={() => setRegionsModalOpen(false)} isOpen={regionsModalOpen} regionCreated={() => getRegions()} />
        </div>
    );
}



type TypeRegionsModalProps = {
    isOpen: boolean,
    onClose: () => void,
    regionCreated: () => void
}
const RegionsModal = (props: TypeRegionsModalProps) => {
    const [region, setRegion] = useState("")
    const [isSavingRegion, setIsSavingRegion] = useState(false);
    const dispatch = useAppDispatch();
    const apiRequest = useApiRequest()
    const accessToken = useAppSelector(selectAccessToken);



    const saveRegion = async () => {
        if (!notEmpty(region)) {
            dispatch(showToastMessage({
                message: "Region is missing",
                type: "error",
                position: toast.POSITION.TOP_CENTER
            }));
            return;
        }
        setIsSavingRegion(true)
        await apiRequest({
            method: 'post',
            url: BASE_URL + "/api/regions/create",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            data: {
                name: region,
            }
        }).then((response) => {
            setIsSavingRegion(false)
            dispatch(showToastMessage({
                message: "Region Created",
                type: "success",
                position: toast.POSITION.TOP_RIGHT
            }));
            props.regionCreated()
            props.onClose()
        }).catch((error) => {
            const errorResponse = error as AxiosError;
            // console.log(errorResponse.response)
            if (errorResponse.response) {
                const data = errorResponse.response.data as { message: string, status: string };
                dispatch(showToastMessage({
                    message: data.message,
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));

            } else {
                dispatch(showToastMessage({
                    message: "Something went wrong",
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            }
            setIsSavingRegion(false)
        });
    }

    return (
        <>
            {(props.isOpen) &&
                <div className="modal ">
                    <div className=" modal-content modal-md py-4">
                        <div className=" flex justify-center">
                            <span className="text-center text-lg">Create Region</span>
                        </div>

                        <div className=" mt-4">
                            <label htmlFor="" className="block text-sm font-medium text-gray-700 ">Region name</label>
                            <input value={region} onChange={(e) => setRegion(e.target.value)} type="text" className="form-input-2" />
                        </div>

                        <div className="flex flex-row-reverse mt-10 pt-4 px-0  gap-2">
                            <div>
                                <AppButton callBackFun={() => saveRegion()} showLoader={isSavingRegion} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2  " text="Save Region" />
                            </div>
                            <div>
                                <button onClick={() => props.onClose()} type="button" className="btn-secondary-1 ">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    )
}


type TypeDistrictsModalProps = {
    isOpen: boolean,
    onClose: () => void,
    districtCreated: () => void
}
const DistrictsModal = (props: TypeDistrictsModalProps) => {
    const [district, setDistrict] = useState("")
    const [isSavingDistrict, setIsSavingDistrict] = useState(false);
    const dispatch = useAppDispatch();
    const apiRequest = useApiRequest()
    const accessToken = useAppSelector(selectAccessToken);
    const [regionsData, setRegionsData] = useState<TypeRegionData[]>([]);
    const [region_id, setRegionId] = useState("");

    useEffect(() => {
        getRegions();
    }, [])

    const getRegions = async () => {
        await apiRequest({
            method: 'get',
            url: BASE_URL + "/api/regions",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }).then((response) => {
            setRegionsData(response.data)
        }).catch((error) => {});
    }

    const saveDistrict = async () => {
        if (!notEmpty(district)) {
            dispatch(showToastMessage({
                message: "District is missing",
                type: "error",
                position: toast.POSITION.TOP_CENTER
            }));
            return;
        }
        if (!notEmpty(region_id)) {
            dispatch(showToastMessage({
                message: "Region is missing",
                type: "error",
                position: toast.POSITION.TOP_CENTER
            }));
            return;
        }
        setIsSavingDistrict(true)
        await apiRequest({
            method: 'post',
            url: BASE_URL + "/api/districts/create",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            data: {
                name: district,
                region_id:region_id
            }
        }).then((response) => {
            setIsSavingDistrict(false)
            dispatch(showToastMessage({
                message: "District Created",
                type: "success",
                position: toast.POSITION.TOP_RIGHT
            }));
            props.districtCreated()
            props.onClose()
        }).catch((error) => {
            const errorResponse = error as AxiosError;
            // console.log(errorResponse.response)
            if (errorResponse.response) {
                const data = errorResponse.response.data as { message: string, status: string };
                dispatch(showToastMessage({
                    message: data.message,
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));

            } else {
                dispatch(showToastMessage({
                    message: "Something went wrong",
                    type: "error",
                    position: toast.POSITION.TOP_RIGHT
                }));
            }
            setIsSavingDistrict(false)
        });
    }

    return (
        <>
            {(props.isOpen) &&
                <div className="modal ">
                    <div className=" modal-content modal-md py-4">
                        <div className=" flex justify-center">
                            <span className="text-center text-lg">Create Subregion</span>
                        </div>

                        <div className=" mt-4">
                            <label htmlFor="" className="block text-sm font-medium text-gray-700 ">Subregion name</label>
                            <input value={district} onChange={(e) => setDistrict(e.target.value)} type="text" className="form-input-2" />
                        </div>

                        <div className=" mt-4">
                            <label htmlFor="" className="block text-sm font-medium text-gray-700 "> Region</label>
                            <select value={region_id} onChange={(e) => setRegionId(e.target.value)} name="" className="form-input-2" id="">
                                <option value="">Select</option>
                                {
                                   regionsData.map((item,key)=><option value={item.id} key={key}>{item.name}</option>) 
                                }
                            </select>
                        </div>

                        <div className="flex flex-row-reverse mt-10 pt-4 px-0  gap-2">
                            <div>
                                <AppButton callBackFun={() => saveDistrict()} showLoader={isSavingDistrict} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2  " text="Save Subregion" />
                            </div>
                            <div>
                                <button onClick={() => props.onClose()} type="button" className="btn-secondary-1 ">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    )
}

export default RegionPage;
